// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import Dynamic from "next/dynamic";
import * as Caml_exceptions from "../../../../node_modules/rescript/lib/es6/caml_exceptions.js";

function MakeLazy(Item) {
  var _addDefault = (function(comp) {
      return comp.make ? comp.make : undefined
    });
  var ImportError = /* @__PURE__ */Caml_exceptions.create("ReactLazy-PorterinUtils.MakeLazy(Item).ImportError");
  var make = function (func, makeProps, loader) {
    var l = Dynamic((function (param) {
            var __x = Curry._1(func, undefined);
            return Js_promise.then_((function (comp) {
                          var m = _addDefault(comp);
                          if (m !== undefined) {
                            return Promise.resolve(Caml_option.valFromOption(m));
                          } else {
                            return Promise.reject({
                                        RE_EXN_ID: ImportError,
                                        _1: "Loaded module is not a component"
                                      });
                          }
                        }), __x);
          }), {
          ssr: false,
          loading: (function (param) {
              return loader;
            })
        });
    return {
            make: l,
            makeProps: makeProps
          };
  };
  return {
          _addDefault: _addDefault,
          ImportError: ImportError,
          make: make
        };
}

var Component = {};

var _addDefault = (function(comp) {
      return comp.make ? comp.make : undefined
    });

var ImportError = /* @__PURE__ */Caml_exceptions.create("ReactLazy-PorterinUtils.MakeLazy(Item).ImportError");

function make(func, makeProps, loader) {
  var l = Dynamic((function (param) {
          var __x = Curry._1(func, undefined);
          return Js_promise.then_((function (comp) {
                        var m = _addDefault(comp);
                        if (m !== undefined) {
                          return Promise.resolve(Caml_option.valFromOption(m));
                        } else {
                          return Promise.reject({
                                      RE_EXN_ID: ImportError,
                                      _1: "Loaded module is not a component"
                                    });
                        }
                      }), __x);
        }), {
        ssr: false,
        loading: (function (param) {
            return loader;
          })
      });
  return {
          make: l,
          makeProps: makeProps
        };
}

var L = {
  _addDefault: _addDefault,
  ImportError: ImportError,
  make: make
};

function make$1(__x) {
  return function (param) {
    return make(__x, (function (param) {
                  
                }), param);
  };
}

var NoProps = {
  Component: Component,
  L: L,
  make: make$1
};

var Suspense = {};

export {
  MakeLazy ,
  NoProps ,
  Suspense ,
}
/* next/dynamic Not a pure module */
